<template>
    <div class="container">
        <div class="handle-box">
            <div class="upload">
                <el-upload ref="upload" class="upload-demo" :data="token" accept=".csv"
                    :action="uploadUrl + '/api/customer.distribution/upload'" :show-file-list="false"
                    :on-success="uploadFileSuccess" :file-list="fileList">
                    <el-button size="small" type="primary">上传客资(csv)</el-button>
                </el-upload>
                <el-button type="success"
                    @click.stop="showDrawerPass(_self, 'uploadDetail', 'showDrawer', ['txt'])">上传客资(txt)</el-button>
                <el-button type="warning"
                    @click.stop="showDrawerPass(_self, 'uploadDetail', 'showDrawer', ['input'])">上传客资(input)</el-button>
                <el-button type="primary" @click="downloadTemplate">下载板模</el-button>
            </div>
            <div>
                <el-date-picker class="date_range mr8" v-model="query.date_range" type="daterange"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                <el-button type="primary" native-type="submit" @click="getTableData">搜索</el-button>
            </div>
        </div>
        <!-- 上传表格 S -->
        <el-table :data="customerData" ref="multipleTable" border highlight-current-row v-loading="loading"
            :height="tableHeight" :max-height="tableHeight">
            <el-table-column prop="id" show-overflow-tooltip label="编号"></el-table-column>
            <el-table-column prop="origin_file_name" show-overflow-tooltip label="原始文件名"></el-table-column>
            <el-table-column prop="sync_yunke" show-overflow-tooltip label="同步云客">
                <template slot-scope="scope">
                    <div v-if="scope.row.sync_yunke==0">不同步</div>
                    <div v-if="scope.row.sync_yunke==1">同步</div>
                </template>
            </el-table-column>
            <el-table-column prop="amount" show-overflow-tooltip label="客资总数"></el-table-column>
            <el-table-column prop="active_amount" show-overflow-tooltip label="非重复数">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                        @click.stop="showDrawerPass(_self, 'detail', 'showDrawer', [scope.row,'noduplicate'])">
                        {{ scope.row.active_amount }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="duplicate_amount" show-overflow-tooltip label="重复数">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                        @click.stop="showDrawerPass(_self, 'detail', 'showDrawer', [scope.row,'duplicate'])">
                        {{ scope.row.duplicate_amount }}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="allocated" show-overflow-tooltip label="有效分配">
                <template slot-scope="scope">
                    <el-link type="primary" v-if="scope.row.allocated=='0'" :underline="false"
                        @click.stop="showDrawerPass(_self, 'allocate', 'showDrawer', [scope.row])">未分配
                    </el-link>
                    <el-link v-if="scope.row.allocated=='1'" :underline="false"
                        @click.stop="showDrawerPass(_self, 'allocate', 'showDrawer', [scope.row])">已分配
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="allocated" show-overflow-tooltip label="重复分配">
                <template slot-scope="scope">
                    <el-link type="primary" v-if="scope.row.duplicate_allocated=='0'" :underline="false"
                        @click.stop="showDrawerPass(_self, 'repeatDetail', 'showDrawer', [scope.row,'duplicate'])">未分配
                    </el-link>
                    <el-link v-if="scope.row.duplicate_allocated=='1'" :underline="false"
                        @click.stop="showDrawerPass(_self, 'repeatDetail', 'showDrawer', [scope.row,'duplicate'])">已分配
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="download" show-overflow-tooltip label="是否导出">
                <template slot-scope="scope">

                    <el-link type="primary" v-if="scope.row.download=='0'" @click.prevent="download(scope.row)">未导出
                    </el-link>
                    <el-link v-if="scope.row.download=='1'" @click.prevent="download(scope.row)">已导出</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="called" show-overflow-tooltip label="已拨打">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                        @click.stop="showDrawerPass(_self, 'repeatDetail', 'showDrawer', [scope.row,'called'])">
                        {{ scope.row.called }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="lost_calls" width="120" show-overflow-tooltip label="未接通">
                <template slot-scope="scope">
                    <div class="flex_box">
                        <div>{{scope.row.lost_calls}}</div>
                        <div>
                            <el-link type="primary" @click.prevent="lostCallDownload(scope.row)"><i
                                    class="el-icon-download"></i></el-link>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="接通率">
                <template slot-scope="scope">
                    {{calculateConnectRate(scope.row.called,scope.row.lost_calls)}}
                </template>
            </el-table-column>
            <el-table-column prop="wash" show-overflow-tooltip label="清洗有效">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                        @click.stop="showDrawerPass(_self, 'detail', 'showDrawer', [scope.row, 'wash'])">
                        {{ scope.row.wash }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="recommend" show-overflow-tooltip label="推荐有效">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false"
                        @click.stop="showDrawerPass(_self, 'detail', 'showDrawer', [scope.row, 'recommend'])">
                        {{ scope.row.recommend }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
            <el-table-column prop="create_time" show-overflow-tooltip label="上传时间"> </el-table-column>
        </el-table>
        <!-- 上传表格 E -->
        <div class="footer-box">
            <div class="pagination" v-if="isPagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]"
                    :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total"></el-pagination>
            </div>
        </div>
        <allocate ref="allocate" :parent="_self"></allocate>
        <detail ref="detail" :parent="_self"></detail>
        <repeat-detail ref="repeatDetail" :parent="_self"></repeat-detail>
        <upload-detail ref="uploadDetail" :parent="_self"></upload-detail>
    </div>
</template>

<script>
import allocate from './upload/allocate'; // 客资分配
import detail from './upload/detail'; // 客资分配
import repeatDetail from './upload/repeatDetail'; // 客资分配
import uploadDetail from './upload/uploadDetail'; // 上传客资
import baseUrl from '@/utils/baseUrl';
import {
    showDrawerPass
} from '@/utils/common.js';
export default {
    namespaced: true,
    name: 'import',
    components: {
        allocate, //添加客资
        detail, //查看详情
        repeatDetail,
        uploadDetail
    },
    props: {
        parent: {},
    },
    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        let uploadUrl = baseUrl;
        return {
            loading: false,
            tableHeight: tableHeight,
            windowheight: windowheight,
            customerData: [],
            query: {
                date_range: []
            },
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            isPagination: {},

            //上传文档
            token: {
                token: localStorage.getItem('token')
            },
            uploadUrl: uploadUrl,
            dialogDocUrl: '',
            dialogDocVisible: false,
            disabled: false,
            fileList: [],
        }
    },
    created() {
        this.getTableData()
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    methods: {
        calculateConnectRate(totalCalls, notDialed) {
            if (totalCalls === 0) {
                return '0';
            } else {
                let calls = totalCalls - notDialed; //总数-未接通　/
                let connectRate = (calls / totalCalls) * 100;
                return connectRate.toFixed(4) + "%";
            }

        },
        uploadFileSuccess(res, file, flieLsit) {
            let _this = this;
            if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: res.msg
                });
            }
            _this.getTableData()

        },
        // 获取列表数据
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/customer.distribution/getList';
            let query = _this.query;
            query.pagination = this.pagination;
            this.$post(url, query).then(function (res) {
                if (res.code == 200) {
                    _this.customerData = res.data.list;
                    _this.pagination = res.data.pagination;
                    _this.loading = false;
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        //下载
        download(row) {
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/exportDuplicateCustomer';
            this.openPostWindow(url, "下载", row.id)

        },
        lostCallDownload(row) {
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/exportNoConnected';
            this.openPostWindow(url, "下载", row.id)
        },
        openPostWindow(url, name, id) {
            var tempForm = document.createElement('form')
            tempForm.id = 'tempForm1'
            tempForm.method = 'post';
            tempForm.action = url;
            tempForm.target = name;
            var hideId = document.createElement("input");
            hideId.type = 'hidden';
            hideId.name = "id";
            hideId.value = id;
            tempForm.appendChild(hideId);
            var hideToken = document.createElement("input");
            hideToken.type = 'hidden';
            hideToken.name = "token";
            hideToken.value = localStorage.getItem("token");
            tempForm.appendChild(hideToken);

            tempForm.addEventListener("onsubmit", function () {
                openWindow(name)
            });
            document.body.appendChild(tempForm);
            tempForm.submit();
            document.body.removeChild(tempForm);

            return false
        },
        openWindow(name) {
            window.open('about:blank', name,
                'height=400,width=400,top=0,left=0,toolbar =yes,menubar =yes,scrollbars=yes,resizable=yes,location=yes,status=yes'
            )
        },

        downloadTemplate() {
            let link = document.createElement('a');
            link.href = 'https://crm.hongsizg.com/tpl.csv';
            link.click();
        }
    }

}
</script>

<style lang="less">
@import url('@/assets/css/member.less');

.date_range {
    margin-left: 20px;
}

.handle-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;

    .upload {
    }

    .upload-demo {
        height: 32px;
        display: inline-block;
        float: left;
    }

    .el-upload--text {
        background-color: #fff;
        border: none;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 120px !important;
        height: 35px !important;
        font-size: 12px;
    }
}
.flex_box {
    display: flex;
    justify-content: space-between;
}
</style>
